import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useTranslation } from "react-i18next";
import Header from "../../layout/Header/Header";
import MenuBotones from "../../MenuBotones";

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);
  const [t] = useTranslation("global");

  if (!user.menuCatalogos) return <Header />;

  return (
    <MenuBotones
      titulo={t("Catálogos")}
      descripcion={t("Clientes, navieras, brokers y demás catálogos del sistema")}
      icono="fas fa-book-open"
      color="#0d9488"
      secciones={[
        {
          section: t("Comercial"),
          items: [
            { label: t("Clientes"), icon: "fas fa-user-tie", color: "#2563eb", href: "/ListadoClientes",
              desc: t("Importadores, datos fiscales y saldos"), enabled: !!user.menuClientes },
            { label: t("Articulos"), icon: "fas fa-tags", color: "#7c3aed", href: "/ListadoArticulos",
              desc: t("Catálogo de artículos"), enabled: !!user.menuArticulos },
            { label: t("Empresas"), icon: "fas fa-building", color: "#475569", href: "/ListadoEmpresas",
              desc: t("Empresas del grupo"), enabled: !!user.menuEmpresas },
          ],
        },
        {
          section: t("Logística"),
          items: [
            { label: t("Navieras"), icon: "fas fa-ship", color: "#0284c7", href: "/ListadoNavieras",
              desc: t("Líneas navieras"), enabled: !!user.menuNavieras },
            { label: t("Agentes aduanales"), icon: "fas fa-user-tie", color: "#0891b2", href: "/ListadoAgentesAduanales",
              desc: t("Opciones que se eligen en la revalidación del contenedor"), enabled: !!user.menuNavieras },
            { label: t("Quién revalida"), icon: "fas fa-stamp", color: "#7c3aed", href: "/ListadoRevalidadores",
              desc: t("Opciones que se eligen al capturar un contenedor"), enabled: !!user.menuNavieras },
            { label: t("Puertos"), icon: "fas fa-anchor", color: "#0369a1", href: "/ListadoPuertos",
              desc: t("Puertos de origen y destino"), enabled: !!user.menuNavieras },
            { label: "Forwarders", icon: "fas fa-globe-americas", color: "#0d9488", href: "/ListadoForwarders",
              desc: t("Agentes de carga"), enabled: !!user.menuForwarders },
            { label: "Brokers", icon: "fas fa-user-shield", color: "#ea580c", href: "/ListadoBrokers",
              desc: t("Agentes aduanales"), enabled: !!user.menuBrokers },
          ],
        },
      ]}
    />
  );
}

export default BotonesCatalogos;
